
// react-bootstrap imports
import { useNavigate } from "react-router-dom"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { Button, Card, Col, Row, Stack } from "react-bootstrap"

import * as Links from "constants/links"

// assets imports
import card_calcTaxaNovo from "assets/card_calcTaxaNovo.png"

const CustomCard = ({ imgSRC, linkText, linkdestiny, buttonOverlayMessage, stateDestiny }) =>
{
    const navigate = useNavigate()

    const overlayMessage = buttonOverlayMessage !== undefined ? <Tooltip variant="primary" > {buttonOverlayMessage} </Tooltip> : <></>

    function redirect()
    {
        navigate(linkdestiny, {state: stateDestiny})
    }

    return (
        <Card style={{width: "18rem"}}>
            <Card.Body className="justify-content-center d-grid gap-3 shadow">
                <img src={imgSRC} className="m-auto" alt="logo" />
                <OverlayTrigger placement="top" delay={{ show: 250, hide: 250 }} overlay={overlayMessage}>
                    <Button className="btn btn-primary shadow rounded-3" onClick={redirect} >{linkText}</Button>
                </OverlayTrigger>
            </Card.Body>
        </Card>
    )
}

const Cards = () =>
{
    return (
        <Stack direction="horizontal" className="justify-content-center">
            <Row>
                <Col>
                    <CustomCard imgSRC={card_calcTaxaNovo} linkText={"Simular taxa"} linkdestiny={Links.SERVICOS_TAXAS_CTM24} />
                </Col>
            </Row>
        </Stack>
    )
}

const Comunicado = () =>
{
    return (
        <></>
    )
}

export default function HomeScreen()
{
    const versao = process.env.REACT_APP_VERSION
    return (
        <div className="container text-center my-auto mb-4" >
            <h1 className="text-primary fs-1 mb-3 text-shadow">Simuladora de taxas de licenciamento urbanístico</h1>
            <h2 className="fs-5 mb-4">Simule aqui sua taxa de licenciamento urbanístico</h2>
            <Comunicado  />
            <Cards />
            <div className="d-flex justify-content-center align-items-center position-relative" >
                <p className="fw-bold mt-3 fs-5">{"Versão "}{versao}</p>
            </div>
        </div>
    )
}